/* LIEVEA — scripts propios */
(function () {
  // Cada sección incluye este archivo: sin esta guarda se ejecuta una vez por sección
  // y cada clic en "Añadir al carrito" añade varias unidades.
  if (window.__lvScriptsCargado) return;
  window.__lvScriptsCargado = true;

  function initReveal() {
    var els = document.querySelectorAll('.pf-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('pf-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('pf-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initFaq() {
    document.querySelectorAll('.pf-faq__item').forEach(function (item) {
      var q = item.querySelector('.pf-faq__q'), a = item.querySelector('.pf-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-pf-galeria]').forEach(function (g) {
      var main = g.querySelector('[data-pf-principal]');
      var minis = g.querySelectorAll('.pf-galeria__mini[data-src]');
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('is-active'); });
          m.classList.add('is-active');
          if (main) { main.src = m.getAttribute('data-src'); main.alt = m.getAttribute('data-alt') || ''; main.style.objectPosition = m.getAttribute('data-pos') || '50% 50%'; }
        });
      });
    });
  }

  function money(cents, fmt) {
    fmt = fmt || '{{amount}} €';
    var n = cents / 100;
    function sep(num, dec, thou, decimals) {
      var s = num.toFixed(decimals);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return decimals ? parts[0] + dec + parts[1] : parts[0];
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = sep(n, '.', ',', 0); break;
      case 'amount_with_comma_separator': v = sep(n, ',', '.', 2); break;
      case 'amount_no_decimals_with_comma_separator': v = sep(n, ',', '.', 0); break;
      case 'amount_with_space_separator': v = sep(n, ',', ' ', 2); break;
      case 'amount_no_decimals_with_space_separator': v = sep(n, ',', ' ', 0); break;
      case 'amount_with_apostrophe_separator': v = sep(n, '.', "'", 2); break;
      default: v = sep(n, '.', ',', 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }

  function initCompra() {
    document.querySelectorAll('[data-pf-compra]').forEach(function (box) {
      var dataEl = box.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var fmt = box.getAttribute('data-money') || '{{amount}} €';
      var idInput = box.querySelector('input[name="id"]');
      var btn = box.querySelector('[data-pf-add]');
      var btnTexto = btn ? btn.getAttribute('data-texto') : '';
      var btnAgotado = btn ? btn.getAttribute('data-agotado') : '';
      var precioEl = box.querySelector('[data-pf-precio]');
      var tachadoEl = box.querySelector('[data-pf-tachado]');
      var mesEl = box.querySelector('[data-pf-mes]');
      var envioEl = box.querySelector('[data-pf-envio]');
            var packs = box.querySelectorAll('.pf-pack');
      var tallas = box.querySelectorAll('.pf-talla');
      var hayTallas = tallas.length > 0;
      var modoOpciones = !!box.querySelector('.pf-pack[data-pack]');
      var avisoTalla = box.querySelector('[data-pf-talla-aviso]');
      var pasoTalla = box.querySelector('[data-pf-paso-talla]');
      var btnSinTalla = btn ? btn.getAttribute('data-sin-talla') : '';
      var estado = { talla: null, pack: null };
      var ahorroEl = box.querySelector('[data-pf-ahorro]');

      function buscar() {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (hayTallas) { if (v.option1 === estado.talla && v.option2 === estado.pack) return v; }
          else if (v.option1 === estado.pack) return v;
        }
        return null;
      }
      function pop(el) { if (!el) return; el.classList.remove('pf-pop'); void el.offsetWidth; el.classList.add('pf-pop'); }
      function pintar() {
        var card = null;
        packs.forEach(function (p) { var on = p.getAttribute('data-pack') === estado.pack; p.classList.toggle('is-selected', on); if (on) card = p; });
        tallas.forEach(function (x) { x.classList.toggle('is-selected', x.getAttribute('data-talla') === estado.talla); });
        var v = buscar();
        var precio = v ? v.price : (card ? parseInt(card.getAttribute('data-precio'), 10) : 0);
        var comparar = card ? parseInt(card.getAttribute('data-comparar'), 10) || 0 : 0; if (v && v.compare_at_price > comparar) comparar = v.compare_at_price;
        var juegos = card ? parseInt(card.getAttribute('data-juegos'), 10) || 1 : 1;
        if (precioEl) { precioEl.textContent = money(precio, fmt); pop(precioEl); }
        if (tachadoEl) { if (comparar > precio) { tachadoEl.textContent = money(comparar, fmt); tachadoEl.style.display = ''; } else { tachadoEl.style.display = 'none'; } }
        if (ahorroEl) { var ah = comparar > precio ? 'Ahorras ' + money(comparar - precio, fmt) : ''; ahorroEl.textContent = ah; ahorroEl.style.display = ah ? '' : 'none'; if (ah) pop(ahorroEl); }
        if (mesEl) { var dias = card ? parseInt(card.getAttribute('data-dias'), 10) || 0 : 0; var partes = []; if (juegos > 1) partes.push(money(Math.round(precio / juegos), fmt) + ' ' + (mesEl.getAttribute('data-sufijo') || '')); if (dias > 0) partes.push('≈ ' + money(Math.round(precio / dias), fmt) + ' ' + (mesEl.getAttribute('data-dia') || 'al día')); mesEl.textContent = partes.join(' · '); mesEl.style.display = partes.length ? '' : 'none'; }
        var falta = hayTallas && !estado.talla;
        box.classList.toggle('pf-sin-talla', falta);
        if (v && idInput) idInput.value = v.id;
        if (btn) {
          var disponible = !v || v.available;
          btn.disabled = !falta && !disponible;
          btn.classList.toggle('pf-btn--espera', falta);
          btn.querySelector('span').textContent = falta ? btnSinTalla : (disponible ? btnTexto : btnAgotado);
        }
        var br0 = box.querySelector('[data-pf-rapido]'); if (br0) br0.disabled = falta || (v && !v.available);
        if (!falta && avisoTalla) avisoTalla.hidden = true;
        box.dispatchEvent(new CustomEvent('pf:variante', { bubbles: true, detail: { variante: v, precio: precio } }));
      }
      function pedirTalla() {
        if (avisoTalla) avisoTalla.hidden = false;
        if (pasoTalla) {
          pasoTalla.classList.remove('pf-temblor'); void pasoTalla.offsetWidth; pasoTalla.classList.add('pf-temblor');
          var r = pasoTalla.getBoundingClientRect();
          if (r.top < 80 || r.bottom > window.innerHeight) window.scrollTo({ top: window.pageYOffset + r.top - 110, behavior: 'smooth' });
        }
      }
      box.pfPedirTalla = pedirTalla;
      box.pfFaltaTalla = function () { return hayTallas && !estado.talla; };

      if (modoOpciones) {
        packs.forEach(function (p) { p.addEventListener('click', function () { estado.pack = p.getAttribute('data-pack'); pintar(); }); });
        tallas.forEach(function (x) { x.addEventListener('click', function () { estado.talla = x.getAttribute('data-talla'); pintar(); }); });
        var packIni = box.querySelector('.pf-pack.is-selected') || packs[0];
        estado.pack = packIni ? packIni.getAttribute('data-pack') : null;
        try { var qs = new URLSearchParams(window.location.search); var tq = qs.get('talla'); if (tq) tallas.forEach(function (x) { if (x.getAttribute('data-talla').toLowerCase() === tq.toLowerCase()) estado.talla = x.getAttribute('data-talla'); }); } catch (e) {}
        pintar();
      } else if (precioEl && variants[0]) {
        precioEl.textContent = money(variants[0].price, fmt);
      }

      // Añadir al carrito por AJAX y abrir el cajón de Dawn si existe
      var form = box.querySelector('form[action*="/cart/add"]');
      if (form && window.fetch) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (box.pfFaltaTalla && box.pfFaltaTalla()) { box.pfPedirTalla(); return; }
          var rapido = !!(ev.submitter && ev.submitter.hasAttribute('data-pf-rapido'));
          var btnRapido = form.querySelector('[data-pf-rapido]');
          if (btn) btn.disabled = true;
          if (btnRapido) btnRapido.disabled = true;
          if (rapido) {
            var fdr = new FormData(form);
            var raiz = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
            fetch(raiz + 'cart/clear.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .catch(function () {})
              .then(function () { return fetch(raiz + 'cart/add.js', { method: 'POST', body: fdr, headers: { 'X-Requested-With': 'XMLHttpRequest' } }); })
              .then(function (r) { return r.json(); })
              .then(function (res) { if (res.status) { alert(res.description || res.message); if (btn) btn.disabled = false; btnRapido.disabled = false; return; } window.location.href = raiz + 'checkout'; })
              .catch(function () { window.location.href = raiz + 'cart/' + (form.querySelector('input[name="id"]').value) + ':1'; });
            return;
          }
          var fd = new FormData(form);
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (cart && typeof cart.getSectionsToRender === 'function') {
            fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
            fd.append('sections_url', window.location.pathname);
          }
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) { alert(res.description || res.message); return; }
              if (cart && typeof cart.renderContents === 'function') { cart.renderContents(res); }
              else { window.location.href = '/cart'; }
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (btn) btn.disabled = false; var br = form.querySelector('[data-pf-rapido]'); if (br) br.disabled = false; });
        });
      }
    });
  }

  function initGuiaTallas() {
    var box = document.querySelector('[data-pf-compra]');
    document.querySelectorAll('[data-pf-elegir-talla]').forEach(function (b) {
      b.addEventListener('click', function () {
        var talla = b.getAttribute('data-pf-elegir-talla');
        var destino = box ? box.querySelector('.pf-talla[data-talla="' + talla + '"]') : null;
        if (destino) {
          destino.click();
          var paso = box.querySelector('[data-pf-paso-talla]') || box;
          window.scrollTo({ top: window.pageYOffset + paso.getBoundingClientRect().top - 110, behavior: 'smooth' });
        } else {
          var url = b.getAttribute('data-url');
          if (url) window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'talla=' + encodeURIComponent(talla);
        }
      });
    });
  }

  function initBarra() {
    var barra = document.querySelector('[data-pf-barra]');
    var box = document.querySelector('[data-pf-compra]');
    if (!barra || !box) return;
    var add = box.querySelector('[data-pf-add]');
    var precio = box.querySelector('[data-pf-precio]');
    var out = barra.querySelector('[data-pf-barra-precio]');
    var btn = barra.querySelector('[data-pf-barra-btn]');
    function sync() { if (precio && out) out.textContent = precio.textContent; }
    sync();
    box.addEventListener('click', function () { setTimeout(sync, 50); });
    if (btn && add) btn.addEventListener('click', function () {
      var form = add.closest('form');
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(add); else add.click();
    });
    if (add) {
      function comprobar() {
        var pasado = add.getBoundingClientRect().bottom < 0;
        barra.classList.toggle('is-visible', pasado);
        barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
      }
      window.addEventListener('scroll', comprobar, { passive: true });
      window.addEventListener('resize', comprobar, { passive: true });
      comprobar();
    }
  }
  function initCarrusel() {
    document.querySelectorAll('[data-pf-carrusel]').forEach(function (c) {
      var pista = c.querySelector('[data-pf-pista]'); if (!pista) return;
      var slides = c.querySelectorAll('[data-pf-slide]'); if (slides.length < 2) return;
      var actual = c.querySelector('[data-pf-actual]'), minis = c.querySelectorAll('[data-pf-ir]');
      var i = 0;
      function ir(n, suave) {
        i = (n + slides.length) % slides.length;
        pista.scrollTo({ left: slides[i].offsetLeft, behavior: suave === false ? 'auto' : 'smooth' });
        pintar();
      }
      function pintar() {
        if (actual) actual.textContent = i + 1;
        c.classList.toggle('pf-no-primera', i !== 0);
        minis.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
        c.querySelectorAll('[data-pf-punto]').forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      }
      var prev = c.querySelector('[data-pf-prev]'), next = c.querySelector('[data-pf-next]');
      if (prev) prev.addEventListener('click', function () { ir(i - 1); });
      if (next) next.addEventListener('click', function () { ir(i + 1); });
      minis.forEach(function (m) { m.addEventListener('click', function () { ir(parseInt(m.getAttribute('data-pf-ir'), 10)); }); });
      var t;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var n = Math.round(pista.scrollLeft / pista.clientWidth);
          if (n !== i && n >= 0 && n < slides.length) { i = n; pintar(); }
        }, 80);
      }, { passive: true });
      c.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') ir(i - 1); if (e.key === 'ArrowRight') ir(i + 1); });

      // Pase automático: avanza solo, se detiene mientras el cliente toca o mira otra cosa
      var seg = parseFloat(c.getAttribute('data-auto') || '0');
      var sinMov = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (seg > 0 && !sinMov) {
        var reloj = null, enPantalla = true, encima = false;
        function parar() { if (reloj) { clearTimeout(reloj); reloj = null; } }
        function programar(espera) {
          parar();
          reloj = setTimeout(function () {
            if (enPantalla && !encima && !document.hidden) ir(i + 1);
            programar(seg * 1000);
          }, espera);
        }
        function tocado() { programar(seg * 2000); }
        ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { pista.addEventListener(ev, tocado, { passive: true }); });
        if (prev) prev.addEventListener('click', tocado);
        if (next) next.addEventListener('click', tocado);
        minis.forEach(function (m) { m.addEventListener('click', tocado); });
        c.addEventListener('mouseenter', function () { encima = true; });
        c.addEventListener('mouseleave', function () { encima = false; });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { enPantalla = es[0].isIntersecting; }, { threshold: 0.4 }).observe(pista);
        }
        programar(seg * 1000);
      }
    });
  }

  function initProgreso() {
    document.querySelectorAll('[data-pf-progreso]').forEach(function (p) {
      var linea = p.querySelector('[data-pf-linea]'), pasos = p.querySelectorAll('[data-pf-paso]');
      if (!linea) return;
      function medir() {
        var r = p.getBoundingClientRect(), vh = window.innerHeight;
        var total = r.height, visto = Math.min(Math.max(vh * 0.62 - r.top, 0), total);
        var pct = total ? visto / total : 0;
        linea.style.transform = 'scaleY(' + pct.toFixed(3) + ')';
        pasos.forEach(function (s) {
          var rs = s.getBoundingClientRect();
          s.classList.toggle('is-activo', rs.top < vh * 0.62);
        });
      }
      window.addEventListener('scroll', medir, { passive: true });
      window.addEventListener('resize', medir, { passive: true });
      medir();
    });
  }

  function initEntrega() {
    document.querySelectorAll('[data-pf-entrega]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '2', 10), max = parseInt(el.getAttribute('data-max') || '4', 10);
      var e = lvEntrega(new Date(), min, max), a = e.a, b = e.b;
      var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      var f = function (d) { return d.getDate() + ' de ' + meses[d.getMonth()]; };
      var oa = el.querySelector('[data-pf-entrega-a]'), ob = el.querySelector('[data-pf-entrega-b]');
      if (oa) oa.textContent = f(a); if (ob) ob.textContent = f(b);
      var mc = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      var oc = el.querySelector('[data-pf-entrega-corta]');
      if (oc) oc.textContent = (a.getMonth() === b.getMonth()) ? (a.getDate() + '–' + b.getDate() + ' ' + mc[b.getMonth()]) : (a.getDate() + ' ' + mc[a.getMonth()] + ' – ' + b.getDate() + ' ' + mc[b.getMonth()]);
      var out = el.querySelector('[data-pf-entrega-fecha]'); if (out) out.textContent = f(a) + ' – ' + f(b);
    });
  }
  var LV_CORTE = 14;
  function lvSumaLaborables(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; } return r; }
  function lvEntrega(cuando, min, max) {
    var hoy = new Date(cuando); if (hoy.getHours() >= LV_CORTE) hoy.setDate(hoy.getDate() + 1);
    hoy.setHours(0, 0, 0, 0);
    return { a: lvSumaLaborables(hoy, min), b: lvSumaLaborables(hoy, max) };
  }
  // Próximo momento en que la fecha de entrega estimada pasa a ser un día más tarde
  function lvProximoCorte(min, max) {
    var ahora = new Date(), actual = lvEntrega(ahora, min, max).a.getTime();
    var c = new Date(ahora); c.setHours(LV_CORTE, 0, 0, 0); if (c <= ahora) c.setDate(c.getDate() + 1);
    for (var i = 0; i < 8; i++) {
      if (lvEntrega(new Date(c.getTime() + 60000), min, max).a.getTime() !== actual) return c;
      c.setDate(c.getDate() + 1);
    }
    return c;
  }
  function initContador() {
    var RE = /^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})/;
    var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
    function finMadrid(str) {
      var m = RE.exec((str || '').trim());
      if (!m) return NaN;
      var utc = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
      try {
        var o = {};
        new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Madrid', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
          .formatToParts(new Date(utc)).forEach(function (x) { o[x.type] = x.value; });
        var local = Date.UTC(+o.year, o.month - 1, +o.day, (+o.hour) % 24, +o.minute);
        return utc - (local - utc);
      } catch (e) { return utc - 7200000; }
    }
    document.querySelectorAll('[data-pf-contador]').forEach(function (el) {
      var envio = el.getAttribute('data-modo') !== 'fecha';
      var min = parseInt(el.getAttribute('data-min') || '5', 10), max = parseInt(el.getAttribute('data-max') || '8', 10);
      var fin;
      function prepara() {
        if (envio) {
          fin = lvProximoCorte(min, max).getTime();
          var e = lvEntrega(new Date(), min, max), oa = el.querySelector('[data-pf-c-a]'), ob = el.querySelector('[data-pf-c-b]');
          if (oa) oa.textContent = (e.a.getMonth() === e.b.getMonth()) ? e.a.getDate() : e.a.getDate() + ' de ' + meses[e.a.getMonth()];
          if (ob) ob.textContent = e.b.getDate() + ' de ' + meses[e.b.getMonth()];
          return true;
        }
        var txt = el.getAttribute('data-fin'); fin = finMadrid(txt);
        if (isNaN(fin) || fin - Date.now() <= 0) return false;
        var m = RE.exec(txt.trim()), dias = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
        var of = el.querySelector('[data-pf-c-fecha]');
        if (of) of.textContent = 'Hasta el ' + dias[new Date(Date.UTC(+m[1], m[2] - 1, +m[3])).getUTCDay()] + ' ' + (+m[3]) + ' de ' + meses[m[2] - 1] + ', ' + m[4] + ':' + m[5] + ' h';
        return true;
      }
      if (!prepara()) return;
      var out = {}; ['d','h','m','s'].forEach(function (k) { out[k] = el.querySelector('[data-pf-c="' + k + '"]'); });
      var cajaD = el.querySelector('[data-pf-c-caja="d"]');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function pon(k, v) { if (out[k] && out[k].textContent !== v) { out[k].textContent = v; out[k].classList.remove('pf-tic'); void out[k].offsetWidth; out[k].classList.add('pf-tic'); } }
      var t;
      function tick() {
        var r = Math.floor((fin - Date.now()) / 1000);
        if (r <= 0) {
          if (envio) { prepara(); document.querySelectorAll('[data-pf-entrega]').length && initEntrega(); r = Math.floor((fin - Date.now()) / 1000); }
          else { el.hidden = true; clearInterval(t); return; }
        }
        var d = Math.floor(r / 86400), h = Math.floor(r % 86400 / 3600), mi = Math.floor(r % 3600 / 60), s = r % 60;
        if (cajaD) { var sin = d === 0; cajaD.hidden = sin; if (cajaD.nextElementSibling) cajaD.nextElementSibling.hidden = sin; }
        pon('d', dos(d)); pon('h', dos(h)); pon('m', dos(mi)); pon('s', dos(s));
      }
      tick(); el.hidden = false; t = setInterval(tick, 1000);
    });
  }
  function initCarrito() {
    var raiz = document.querySelector('[data-pf-carrito]'); if (!raiz) return;
    var sec = raiz.getAttribute('data-seccion'), ocupado = false;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var aviso = raiz.querySelector('[data-pf-aviso]');
    function post(url, body) {
      return fetch(base + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }
    function refrescar() {
      return fetch(base + 'cart?sections=' + sec + ',cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (m) {
          var doc = new DOMParser().parseFromString(m[sec] || '', 'text/html');
          var nuevo = doc.querySelector('[data-pf-carrito]');
          if (!nuevo || nuevo.hasAttribute('data-vacio')) { location.reload(); return; }
          raiz.querySelectorAll('[data-pf-parte]').forEach(function (p) {
            var n = nuevo.querySelector('[data-pf-parte="' + p.getAttribute('data-pf-parte') + '"]');
            if (n) p.innerHTML = n.innerHTML;
          });
          var burbuja = document.getElementById('cart-icon-bubble');
          if (burbuja && m['cart-icon-bubble']) {
            var b = new DOMParser().parseFromString(m['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (b) burbuja.innerHTML = b.innerHTML;
          }
          initEntrega();
        });
    }
    function hacer(promesa) {
      if (ocupado) return; ocupado = true; raiz.classList.add('is-cargando'); if (aviso) aviso.hidden = true;
      promesa().then(refrescar).catch(function (e) {
        if (aviso) { aviso.textContent = (e && (e.description || e.message)) || 'No hemos podido actualizar la cesta. Inténtalo de nuevo.'; aviso.hidden = false; }
        return refrescar().catch(function () {});
      }).then(function () { ocupado = false; raiz.classList.remove('is-cargando'); });
    }
    raiz.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-pf-cant],[data-pf-quitar],[data-pf-cambiar]'); if (!b) return;
      ev.preventDefault();
      var key = b.getAttribute('data-key');
      if (b.hasAttribute('data-pf-cambiar')) {
        var v = parseInt(b.getAttribute('data-variante'), 10);
        hacer(function () { return post('cart/change.js', { id: key, quantity: 0 }).then(function () { return post('cart/add.js', { items: [{ id: v, quantity: 1 }] }); }); });
        return;
      }
      var q = b.hasAttribute('data-pf-quitar') ? 0 : Math.max(0, parseInt(b.getAttribute('data-actual'), 10) + parseInt(b.getAttribute('data-pf-cant'), 10));
      hacer(function () { return post('cart/change.js', { id: key, quantity: q }); });
    });
    var barra = raiz.querySelector('[data-pf-barra-carrito]'), boton = raiz.querySelector('[data-pf-pagar]');
    if (barra && boton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { barra.classList.toggle('is-oculta', en[0].isIntersecting); }, { threshold: 0.2 }).observe(boton);
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    initCarrito(); initContador();
    initReveal(); initFaq(); initGaleria(); initCompra(); initEntrega(); initBarra(); initGuiaTallas(); initCarrusel(); initProgreso();
  });
})();
